// DragMotivatorsTable.jsx
import { useMemo } from 'react';
import {
  useMaterialReactTable,
  MRT_TableContainer,
} from 'material-react-table';

const DragMotivatorsTable = ({ motivators, setMotivators }) => {
  const columns = useMemo(
    () => [
        {
          accessorKey: 'index',
          header: 'Priorities',
          size: 20, // Decrease the width of the Priorities column
          muiTableHeadCellProps: {
            style: {
              width: '20px',
              textAlign: 'center', // Center align the header text
            },
          },
          muiTableCellProps: {
            style: {
              maxWidth: '30px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              textAlign: 'center', // Center align the cell text
            },
          },
        },
        {
          accessorKey: 'name',
          header: 'Work Motivator',
          size: 100,
          muiTableHeadCellProps: {
            style: {
              width: '1650px',
            },
          },
          muiTableCellProps: {
            style: {
              maxWidth: '1650px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            },
          },
        },
      ],
      []
    );

  const dataWithIndex = motivators.map((motivator, index) => ({
    ...motivator,
    index: index + 1, // Add an index property to each motivator
  }));

  const table = useMaterialReactTable({
    autoResetPageIndex: false,
    columns,
    data: dataWithIndex, // Use the modified data with index
    enableRowOrdering: true,
    enableSorting: false,
    displayColumnDefOptions: {
      'mrt-row-drag': {
        header: 'Move',
        muiTableHeadCellProps: {
          title: "Drag & Drop rows to reorder priorities",
          style: {
             cursor: 'help'
          }
        }
      },
    },
    muiRowDragHandleProps: ({ table }) => ({
      onDragEnd: () => {
        const { draggingRow, hoveredRow } = table.getState();
        if (hoveredRow && draggingRow) {
          const newMotivators = [...motivators];
          newMotivators.splice(
            hoveredRow.index,
            0,
            newMotivators.splice(draggingRow.index, 1)[0]
          );
          setMotivators(newMotivators);
        }
      },
    }),
  });

  return <MRT_TableContainer table={table} />;
};

export default DragMotivatorsTable;